import {
    Star,
    Check,
    CheckCircle,
    Zap,
    Sparkles,
    Rocket,
    Shield,
    Settings,
    Layers,
    Package,
    Clock,
    Code,
    Database,
    Globe,
    TrendingDown,
    TrendingUp,
    Heart,
    Smile,
    Target,
    KeyRound,
    Workflow,
    Plug,
    ClipboardList,
    MessageSquare,
    FolderOpen,
    CalendarDays,
    Briefcase,
    CreditCard,
    Bot,
    BarChart3,
    ScrollText,
    type LucideIcon,
} from "lucide-react";

export type IconName =
    | "Star"
    | "Check"
    | "CheckCircle"
    | "Zap"
    | "Sparkles"
    | "Rocket"
    | "Shield"
    | "Settings"
    | "Layers"
    | "Package"
    | "Clock"
    | "Code"
    | "Database"
    | "Globe"
    | "TrendingDown"
    | "TrendingUp"
    | "Heart"
    | "Smile"
    | "Target"
    | "KeyRound"
    | "Workflow"
    | "Plug"
    | "ClipboardList"
    | "MessageSquare"
    | "FolderOpen"
    | "CalendarDays"
    | "Briefcase"
    | "CreditCard"
    | "Bot"
    | "BarChart3"
    | "ScrollText";

export const iconMap: Record<IconName, LucideIcon> = {
    Star,
    Check,
    CheckCircle,
    Zap,
    Sparkles,
    Rocket,
    Shield,
    Settings,
    Layers,
    Package,
    Clock,
    Code,
    Database,
    Globe,
    TrendingDown,
    TrendingUp,
    Heart,
    Smile,
    Target,
    KeyRound,
    Workflow,
    Plug,
    ClipboardList,
    MessageSquare,
    FolderOpen,
    CalendarDays,
    Briefcase,
    CreditCard,
    Bot,
    BarChart3,
    ScrollText,
};

export const getIcon = (iconName?: string): LucideIcon => {
    if (!iconName) {
        return Star; // default
    }
    return iconMap[iconName as IconName] || Star;
};
